import { render, staticRenderFns } from "./NavBottom.vue?vue&type=template&id=dadd3850"
import script from "./NavBottom.vue?vue&type=script&lang=js"
export * from "./NavBottom.vue?vue&type=script&lang=js"
import style0 from "./NavBottom.vue?vue&type=style&index=0&id=dadd3850&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports